export default __webpack_public_path__ + "static/media/pvilla5-1.ff516c31.jpg";